// Общие константы и хелперы кабинета и страницы тарифов
export const PACK_PRICE = 50;

export const EASE = [0.16, 1, 0.3, 1];

export const rise = (i = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
  transition: { duration: 0.9, delay: i * 0.06, ease: EASE },
});

export const pluralTryons = (n) => {
  if (n % 10 === 1 && n % 100 !== 11) return "примерку";
  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) return "примерки";
  return "примерок";
};

export const pluralGensNom = (n) =>
  n % 10 === 1 && n % 100 !== 11
    ? "примерка"
    : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)
      ? "примерки"
      : "примерок";

export const fmtDay = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("ru-RU", { day: "numeric", month: "long" });
};

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("ru-RU", { day: "numeric", month: "long" });
  } catch {
    return "";
  }
};

export const fmtFull = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("ru-RU", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

export const fieldCls =
  "w-full border-b border-white/10 bg-transparent px-0 py-3.5 font-manrope text-base text-[#F4F4F0] placeholder:text-[#525252] focus:border-[#C2A878] focus:outline-none transition-colors duration-300 rounded-none";
export const btnGoldSolid =
  "flex h-13 w-full items-center justify-center gap-2 border border-[#C2A878] bg-[#C2A878] px-6 py-3.5 font-jetbrains text-[11px] uppercase tracking-[0.2em] text-[#0A0A0A] transition-colors duration-300 hover:bg-[#D4BA8A] hover:border-[#D4BA8A] disabled:opacity-50";
export const btnGold =
  "flex w-full items-center justify-center gap-2 border border-[#C2A878] px-6 py-3.5 font-jetbrains text-[11px] uppercase tracking-[0.2em] text-[#C2A878] transition-colors duration-300 hover:bg-[#C2A878] hover:text-[#0A0A0A] disabled:opacity-50";
export const btnGhost =
  "flex w-full items-center justify-center gap-2 border border-white/10 px-6 py-3.5 font-jetbrains text-[11px] uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-300 hover:border-[#C2A878]/60 hover:text-[#C2A878] disabled:opacity-50";

export const planFeatures = (p) => [
  `${p.generations} ${pluralGensNom(p.generations)} в месяц — примерка новой стрижки на вашем фото`,
  "Точный разбор лица по 68 точкам, оценка текущей стрижки и 9 рекомендаций под ваши замеры",
  "Все маски: Марквардт, линии золотого сечения, профиль",
  "Сохранение примерок в HD и история в личном кабинете",
  ...(p.is_pro ? ["Техкарта стрижки для мастера: зоны, длины в сантиметрах, углы, порядок работы"] : []),
  "Без автопродления и скрытых списаний",
];
